import React from "react";
import { Platform, TouchableOpacity, View } from "react-native";
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, TypographyTypeDLS } from "@voltmoney/schema";
import ThemeProvider from "@voltmoney/theme";
import { Icon } from "../icon/Icon";
import { Space } from "../space/Space";
import { Typography } from "../typography/Typography";
import { Button } from "../button/Button";
import { isMobileViewApp } from "../stack/utils";
import { addCommasToNumber } from "../pages/utils";
const LoanRenewalDashboardCard = ({ creditLimitAmount, amount = 0, loanExpiryDays, learnMoreAction, show, ctaAction, triggerAction }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const isFromMobileViewApp = isMobileViewApp();
    const _isFontMobile = () => {
        if (Platform.OS !== "web") {
            return true;
        }
        else if (isFromMobileViewApp) {
            return true;
        }
        else {
            return false;
        }
    };
    const isFontMobile = _isFontMobile();
    const calExpiryTitle = () => {
        let label = '';
        if (loanExpiryDays === '0') {
            label = `Your loan renewal is due today!`;
        }
        else if (loanExpiryDays === '1') {
            label = `Your loan will expire in ${loanExpiryDays} day!`;
        }
        else
            label = `Your loan will expire in ${loanExpiryDays} days!`;
        return label;
    };
    const LoanRenewalCard = () => {
        return (React.createElement(View, { style: {
                borderRadius: 12,
                borderWidth: 1,
                borderColor: colorMapping[ColorTokens.Grey_Chalk],
                padding: 16,
                backgroundColor: colorMapping[ColorTokens.White]
            } },
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_ERROR_DLS, size: IconSizeTokens.MD }),
                React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                React.createElement(Typography, { label: calExpiryTitle(), typeDLS: TypographyTypeDLS.H4S })),
            React.createElement(Space, { size: SizeTypeTokens.LG }),
            React.createElement(Typography, { label: amount > 0 ? 'Outstanding amount' : 'Credit limit', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                } },
                React.createElement(Typography, { label: `₹`, fontWeight: '700', color: amount > 0 ? ColorTokens.System_Error : ColorTokens.Grey_Night, fontSize: isFontMobile ? FontSizeTokens.XXXXL : FontSizeTokens.XXL, lineHeight: Platform.OS === "android" ? 40 : 32 }),
                React.createElement(Typography, { label: amount > 0 ? `${addCommasToNumber(amount)}` : `${addCommasToNumber(creditLimitAmount)}`, typeDLS: TypographyTypeDLS.H1B, color: amount > 0 ? ColorTokens.System_Error : ColorTokens.Grey_Night })),
            React.createElement(Space, { size: SizeTypeTokens.LG }),
            React.createElement(TouchableOpacity, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    borderRadius: 8,
                    padding: 8,
                    backgroundColor: colorMapping[ColorTokens.Grey_Milk_1]
                }, onPress: () => {
                    learnMoreAction &&
                        triggerAction(learnMoreAction);
                } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_DLS, size: IconSizeTokens.XL }),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(Typography, { label: `What happens if I do not renew?`, typeDLS: TypographyTypeDLS.B2M }),
                React.createElement(View, null,
                    React.createElement(Typography, { label: ` Learn more`, typeDLS: TypographyTypeDLS.B2M, color: ColorTokens.Primary_100 }))),
            React.createElement(Space, { size: SizeTypeTokens.LG }),
            React.createElement(Button, { label: 'Renew now', typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, onPress: () => {
                    ctaAction &&
                        triggerAction(ctaAction);
                } })));
    };
    return (React.createElement(View, { style: {
            width: '100%',
            paddingHorizontal: 16,
            paddingBottom: 16,
            borderBottomWidth: 1,
            borderBottomColor: colorMapping[ColorTokens.Grey_Chalk]
        } }, LoanRenewalCard()));
};
export default (LoanRenewalDashboardCard);
